import messages from './cmsLifecycleToast.json' with { type: 'json' };

export const cmsLifecycleToastEn: Readonly<typeof messages> = messages;
